<script>
export default {
  props: {
    carouselList: {
      type: Array,
      default: () => {
        return []
      },
    },
    kind: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mobile: false,
    }
  },
  created() {
    const vm = this
    if (window.innerWidth < 576) {
      vm.mobile = true
    }
  },
  destroyed() {
    const vm = this
    vm.mobile = false
  },
  methods: {
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    },
  },
}
</script>
<template>
  <div :class="$style.multiple">
    <div class="multiple__box">
      <div class="multiple-box">
        <BaseSectionTitle title="多元學習及訓練剪影" class="text-center" />
        <template v-if="mobile === true">
          <el-carousel ref="carousel" :autoplay="true" indicator-position="none" arrow="never" height="900px">
            <el-carousel-item v-for="(item, index) of carouselList" :key="index">
              <img :src="item.image" alt="" class="img" />
              <div class="word">
                <p class="word-title">{{ item.title }}<span class="bottom-line"></span></p>
                <p class="word-text">{{ item.description }}</p>
              </div>
            </el-carousel-item>
            <!-- <div class="arrow left" @click="prev">
              <span class="arrow-inner"><i class="fal fa-chevron-left"></i></span>
            </div>
            <div class="arrow right" @click="next">
              <span class="arrow-inner"><i class="fal fa-chevron-right"></i></span>
            </div> -->
          </el-carousel>
        </template>
        <template v-else>
          <el-carousel ref="carousel" type="card" :autoplay="false" indicator-position="none" arrow="never" height="1000px">
            <el-carousel-item v-for="(item, index) of carouselList" :key="index">
              <img :src="item.image" alt="" class="img" />
              <div class="word">
                <p class="word-title">{{ item.title }}<span class="bottom-line"></span></p>
                <p class="word-text">{{ item.description }}</p>
              </div>
            </el-carousel-item>
            <div class="arrow left" @click="prev">
              <span class="arrow-inner"><i class="fal fa-chevron-left"></i></span>
            </div>
            <div class="arrow right" @click="next">
              <span class="arrow-inner"><i class="fal fa-chevron-right"></i></span>
            </div>
          </el-carousel>
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.multiple {
  background: $color-gray-2;
  :global {
    .multiple {
      &__box {
        background-color: #ffffff;
        .multiple-box {
          padding-top: 70px;
          padding-bottom: 70px;
          position: relative;
          .detail {
            margin-bottom: 60px;
            font-size: 1.125rem;
            color: $color-gray-6;
            text-align: center;
          }
          .el-carousel__item {
            background-color: #ffffff;
            padding-top: 80px;
            @include max-sm {
              padding: 0px;
            }
            .img {
              height: 500px;
              width: 100%;
              object-fit: cover;
              object-position: center;
            }
            .word {
              visibility: hidden;
            }
            @include max-lg {
              .img {
                height: 400px;
              }
            }
            @include max-md {
              .img {
                height: 350px;
              }
            }
            @include max-sm {
              .img {
                height: 300px;
              }
            }
          }
          .is-active {
            padding-top: 0;
            .word {
              visibility: visible;
            }
          }
          .el-carousel__mask {
            opacity: 0.7;
          }
          .arrow {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            top: 35%;
            width: 53px;
            height: 53px;
            border-radius: 25px;
            z-index: 5;
            border: 1px solid #4d5561;
            opacity: 0.7;
            padding: 10px;
            cursor: pointer;
            @include max-md {
              width: 40px;
              height: 40px;
            }
            @include max-sm {
              top: 18%;
              background-color: #ffffffbb;
            }
          }
          .arrow:hover {
            border: none;
            opacity: 1;
            background-color: $color-primary;
          }
          .arrow:hover .arrow-inner {
            color: #ffffff;
          }
          .left {
            left: 18%;
            @include max-lg {
              left: 16%;
            }
            @include max-md {
              left: 14%;
            }
            @include max-sm {
              left: 2%;
            }
          }
          .right {
            right: 18%;
            .arrow-inner {
              transform: translateX(1px);
            }
            @include max-lg {
              right: 16%;
            }
            @include max-md {
              right: 14%;
            }
            @include max-sm {
              right: 2%;
            }
          }
          .word {
            margin: 2px;
            padding: 38px;
            background-color: #ffffff;
            box-shadow: 0px 2px 6px #00000029;
            z-index: 10;
            .word-title {
              position: relative;
              font-size: 24px;
              color: $color-gray-8;
              &::before {
                position: absolute;
                bottom: -20px;
                left: 0;
                width: 5px;
                height: 5px;
                content: '';
                background-color: $color-primary;
                border-radius: 50%;
                @include max-md {
                  bottom: -0.875rem;
                }
              }

              &::after {
                position: absolute;
                bottom: -20px;
                left: 10px;
                width: 5px;
                height: 5px;
                content: '';
                background-color: $color-primary;
                border-radius: 50%;
                @include max-md {
                  bottom: -0.875rem;
                }
              }
            }
            .bottom-line {
              position: absolute;
              bottom: -20px;
              left: 20px;
              width: 30px;
              height: 5px;
              background-color: $color-primary;
              border-radius: 4px;
              @include max-md {
                bottom: -0.875rem;
              }
            }
            .word-text {
              margin-top: 42px;
              font-size: 18px;
              line-height: 1.5;
              color: $color-gray-6;
            }
          }
          @include max-md {
            .word {
              padding: 20px;
              .word-title {
                font-size: 20px;
              }
              .word-text {
                margin-top: 25px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>